var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreatorFeatureLasso(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 486,
    height: 503,
    viewBox: "0 0 486 503",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5625_38343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.788 30.5274C147.169 38.3938 121.435 56.008 107.399 84.8475C82.2509 136.519 94.9354 173.3 86.809 211.132C78.6826 248.965 50.3044 262.502 30.5807 292.559C15.1855 316.019 15.9297 362.516 44.435 398.731C68.9494 429.875 101.321 449.551 152.532 440.115C203.237 431.005 227.768 395.829 280.942 383.335C334.115 370.842 378.786 379.168 406.417 352.807C435.391 325.165 463.975 250.431 435.484 198.127C412.567 156.058 360.039 148.219 333.215 108.964C306.391 69.7094 293.568 52.2592 271.277 43.4021C240.462 31.1579 217.346 24.0992 185.788 30.5274Z",
    stroke: "#FFFFFF",
    strokeOpacity: 0.24,
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5625_38343"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 485.488,
    height: 502.539,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatorFeatureLasso);
export default __webpack_public_path__ + "static/media/creator-feature-lasso.a709e804157316c4d5f194fa0ddf5fbd.svg";
export { ForwardRef as ReactComponent };